import { marqueeItems } from "../../data/site";

export default function Marquee() {
  const items = [...marqueeItems, ...marqueeItems];
  return (
    <div className="relative overflow-hidden border-y border-white/5 bg-ink-950/50 py-6" data-testid="marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-ink-950 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-ink-950 to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-12">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="whitespace-nowrap font-heading text-xl font-medium tracking-tight text-slate-500">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-sky-400/50" />
          </div>
        ))}
      </div>
    </div>
  );
}
